import http from '../../utils/fetch';
export default {
    login(query) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/selectPage',
            method: 'post',
            params: query
        });
    },
    logout(query) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/selectPage',
            method: 'post',
            params: query
        });
    },
    getNowUser(){
        return http.post('/api/swyl/v1/basic/bscUserInfo/getNowUser')
    }
}